// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spinner, Container } from 'react-bootstrap'; // For loading state

function ProtectedRoute({ children }) {
  const { currentUser, token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Container className="text-center mt-5"><Spinner animation="border" /> Verifying session...</Container>;
  }

  return token && currentUser ? children : <Navigate to="/login" state={{ from: location }} replace />;
}

export default ProtectedRoute;